// 環境変数
export const ENV = {
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  SUPABASE_KEY: import.meta.env.VITE_SUPABASE_KEY,
  NODE_ENV: import.meta.env.MODE,
  API_URL: import.meta.env.VITE_API_URL,
} as const;

// アプリケーション設定
export const APP_CONFIG = {
  DEFAULT_LOCALE: 'ja',
  DATE_FORMAT: 'YYYY-MM-DD',
  DATETIME_FORMAT: 'YYYY-MM-DD HH:mm:ss',
  PAGE_SIZE: 10,
} as const;

// レースクラス
export const RACE_CLASSES = {
  IRC1: 'IRC Class 1',
  IRC2: 'IRC Class 2',
  IRC3: 'IRC Class 3',
  J24: 'J/24',
  OPEN: 'Open',
} as const;

// バリデーションルール
export const VALIDATION_RULES = {
  REQUIRED: { required: true },
  MIN_VALUE: (min: number) => ({ min, type: 'number' as const }),
  MAX_VALUE: (max: number) => ({ max, type: 'number' as const }),
  MIN_LENGTH: (min: number) => ({ min, type: 'string' as const }),
  MAX_LENGTH: (max: number) => ({ max, type: 'string' as const }),
} as const;

// APIエンドポイント
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
  },
  RACE: {
    BASE: '/races',
    LIST: '/races',
    CREATE: '/races/create',
    UPDATE: '/races/:id',
    DELETE: '/races/:id',
  },
  APPLICATION: {
    BASE: '/applications',
    LIST: '/applications',
    CREATE: '/applications/create',
    UPDATE: '/applications/:id',
    DELETE: '/applications/:id',
  },
} as const;
